<template>
<div class="container-fluid">
	<img v-if="!data_loaded" class="center-me" src="/images/loading-color.svg">

	<template v-if="perms.can_create_org">

		<div class="row">
		    <div class="col">
				<h1>Create Organization</h1>
			</div>
		</div>

		<form @submit.prevent="submitForm" @keydown="form.onKeydown($event)" @change="form.onKeydown($event)" class="mb-0">
			<alert-errors :form="form">There were some problems with your input.</alert-errors>
			<div class="row">		
			    <div class="col-12">
				    <div class="card">
					    <div class="card-header">Basic Info</div>
						<div class="card-body row">

							<div class="col">
							    <div class="form-group">
							    	<label class="mb-0">Organization Name</label>
							    	<input class="form-control" v-model="form.name" required data-test="orgName">
							    </div>

							    <div class="form-group">
							    	<label class="mb-0">Status</label>
			                        <v-select   
			                        	:clearable="false"     
			                            :options="[
			                            	{ label:'Active', value:1 },
			                            	{ label:'Inactive', value:0 }
			                            ]"
			                            :reduce="label => label.value"
			                            v-model="form.status"
			                            data-test="orgStatus"
			                        />
							    </div>

							    <div class="form-group">
							    	<label class="mb-0">Theme / White Label</label>
			                        <v-select 
			                        	:clearable="false"       
			                            :options="[
			                            	{ label:'Default / None', value:null },
			                            	{ label:'FlightPlan', value:'flightplan' }
			                            ]"
			                            :reduce="label => label.value"
			                            v-model="form.theme"
			                            data-test="orgTheme"
			                        />
							    </div>
							</div>
						</div>
					</div>
				</div>


				<div class="col-12">
					<div class="card">
					    <div class="card-header">Assign Clients & Users</div>
					    <div class="card-body row">
						    <div class="form-group col-md-6" data-test="clientsList">
								<label class="mb-2 text-blue-700 font-weight-bold">Clients</label>
								<div v-for="client in client_list.filter(client => !client.org_id)" class="form-check">
									<input class="form-check-input" type="checkbox" v-model="form.clients" :value="client.id">
									<label class="form-check-label">{{ client.name }}</label>
								</div>
						    </div>				    				    	
					    
						    <div class="form-group col-md-6" data-test="usersList">
						    	<label class="mb-2 text-blue-700 font-weight-bold">Available Users</label>
								<div v-for="user in clientUsers" class="d-flex form-check mb-2">
									<input class="form-check-input" type="checkbox" v-model="form.users" :value="user.id">
									<div class="rounded-circle avatar-xs circle-cropped mr-2">
										<img class="img-fluid" :src="user.photo_url">
									</div>
									<div>
										<span class="font-weight-bold">{{ user.display_name }}</span>
										<span v-for="role in user.roles" class="badge bg-blue-100 text-blue-700 mr-1">{{ role.name }}</span>
									</div>
								</div>
							</div>

					    </div>


					    <div class="card-footer">
					    	Existing clients not listed here have already been assigned to an organization. To change an existing association, edit that client directly. Assigning a user will not change their client assigments, but will give them permission to view organization-level views for the clients they have.
					    </div>
					</div>
				</div>

				<div class="col-12">
				    <div class="form-group">
				    	<button type="submit" class="btn btn-primary" data-test="saveOrgButton">Save Organization</button>
					</div>
				</div>

			</div>
		</form>
	</template>
</div>
</template>

<script>
	import { mapGetters, mapState } from 'vuex';
	import BreadcrumbsManager from '../../helpers/BreadcrumbManager';
	import { Form, HasError, AlertError, AlertErrors, AlertSuccess } from 'vform';

    export default {

    	mixins: [BreadcrumbsManager],

    	components: {
            HasError,
            AlertError,
            AlertErrors,
            AlertSuccess,
            Form    		
    	},

        data () {
            return {
                data_loaded: true,
                form: new Form({
                    name: null,
                    status: 1,
					theme: null,
					clients: [],
					users: [],
                }),
                users: [],
            }
        },

        created() {
        	this.fetchUsers();
        },

        activated() {
        	this.setBreadcrumbs([
                { text: 'Home', to: { name: 'home' } },
                { text: 'Organizations', to: { name: 'orgs.index' } },
                { text: 'Create Organization', to: { name: 'orgs.create' } },
            ]);  
        },

        methods: {
			// fetchClients() {
			// 	axios.get('/api/admin/clients').then(({data}) => {
			// 		this.clients = data;
			// 	});
			// },

			fetchUsers() {
				axios.get('/api/admin/users').then(({data}) => {
					this.users = data;
				});
			},

        	submitForm() { 
            	this.data_loaded = false;

                this.form.post('/api/admin/orgs').then(({ data }) => {
					Swal.fire({
						toast: true,
						position: 'top-end',
						showConfirmButton: false,
						timer: 4000,
						icon: 'success',
						title: 'Organization created',
					});	
                	this.form.name = null;
                	this.form.theme = null;
                	this.form.clients = [];
                	this.form.users = [];
                	
                	this.$router.push({ name: 'orgs.index' });
            		this.data_loaded = true;
            	});

        	},
          
        },

        computed: {
        	...mapState(['options', 'perms', 'user']),
        	...mapGetters(['client_list']),

        	clientUsers() {
				return this.users.filter(user => { 
					return user.client_list_all.some(client => {
						return this.form.clients.includes(client.id);
					});
				});
        	}
        },
    }
</script>

<style>
</style>